// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViewTimeOffModal_backdrop__Jlw4B {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(16, 24, 40, 0.12);
  backdrop-filter: blur(4px);
  padding: 22px;
}

.ViewTimeOffModal_modal__FwpZ3 {
  position: relative;
  width: 500px;
  max-width: 95%;
  background: #ffffff;
  border-radius: 16px;
  padding: 40px 36px;
  box-shadow: 0 25px 50px rgba(15, 23, 42, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.05);
  text-align: left;
  -webkit-font-smoothing: antialiased;
  animation: ViewTimeOffModal_modalSlideIn__xz8C2 0.3s ease-out;
}

@keyframes ViewTimeOffModal_modalSlideIn__xz8C2 {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(-10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
.ViewTimeOffModal_closeBtn__I1tRp {
  position: absolute !important;
  top: 16px;
  right: 16px;
  width: 44px !important;
  height: 44px !important;
  min-width: 0 !important;
  border-radius: 50% !important;
  background: var(--white) !important;
  box-shadow: 0 8px 20px rgba(17, 24, 39, 0.08) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 !important;
  cursor: pointer;
  border: none !important;
  transition: all 0.2s ease !important;
}
.ViewTimeOffModal_closeBtn__I1tRp:hover {
  background: #f8f9fa !important;
  box-shadow: 0 10px 25px rgba(17, 24, 39, 0.12) !important;
  transform: scale(1.05);
}
.ViewTimeOffModal_closeBtn__I1tRp img {
  width: 20px !important;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}
.ViewTimeOffModal_closeBtn__I1tRp:hover img {
  opacity: 1;
}

.ViewTimeOffModal_title__9-0ud {
  font: var(--h3);
  font-family: var(--font-bodoni-72);
  font-weight: 700;
  font-size: 28px;
  line-height: 34px;
  color: #1f2937;
  margin: 0 0 32px;
  text-transform: none;
}

.ViewTimeOffModal_detailsContainer__dQdOT {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.ViewTimeOffModal_detailRow__D8\\+th {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 16px 0;
  border-bottom: 1px solid #f3f4f6;
}
.ViewTimeOffModal_detailRow__D8\\+th:last-child {
  border-bottom: none;
}

.ViewTimeOffModal_label__JgSKH {
  font-weight: 600;
  color: #374151;
  font-size: 16px;
  min-width: 140px;
  flex-shrink: 0;
}

.ViewTimeOffModal_value__YU5w5 {
  color: #1f2937;
  font-size: 16px;
  line-height: 1.5;
  text-align: right;
  word-break: break-word;
}

.ViewTimeOffModal_statusBadge__3kRS1 {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 14px;
  text-transform: capitalize;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

@media screen and (max-width: 767px) {
  .ViewTimeOffModal_modal__FwpZ3 {
    padding: 28px 24px;
    width: 90%;
    border-radius: 12px;
  }
  .ViewTimeOffModal_closeBtn__I1tRp {
    width: 36px !important;
    height: 36px !important;
    top: 12px;
    right: 12px;
  }
  .ViewTimeOffModal_closeBtn__I1tRp img {
    width: 16px !important;
  }
  .ViewTimeOffModal_title__9-0ud {
    font-size: 24px;
    line-height: 30px;
    margin-bottom: 24px;
  }
  .ViewTimeOffModal_detailRow__D8\\+th {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding: 12px 0;
  }
  .ViewTimeOffModal_label__JgSKH {
    min-width: auto;
  }
  .ViewTimeOffModal_value__YU5w5 {
    text-align: left;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/modal/ViewTimeOffModal.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wCAAA;EACA,0BAAA;EACA,aAAA;AACD;;AAEA;EACC,kBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mFACC;EAED,gBAAA;EACA,mCAAA;EACA,6DAAA;AADD;;AAIA;EACC;IACC,UAAA;IACA,wCAAA;EADA;EAGD;IACC,UAAA;IACA,iCAAA;EADA;AACF;AAIA;EACC,6BAAA;EACA,SAAA;EACA,WAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,6BAAA;EACA,mCAAA;EACA,wDAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,qBAAA;EACA,eAAA;EACA,uBAAA;EACA,oCAAA;AAFD;AAIC;EACC,8BAAA;EACA,yDAAA;EACA,sBAAA;AAFF;AAKC;EACC,sBAAA;EACA,YAAA;EACA,6BAAA;AAHF;AAMC;EACC,UAAA;AAJF;;AAQA;EACC,eAAA;EACA,kCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;AALD;;AAQA;EACC,aAAA;EACA,sBAAA;EACA,SAAA;AALD;;AAQA;EACC,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,eAAA;EACA,gCAAA;AALD;AAOC;EACC,mBAAA;AALF;;AASA;EACC,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAND;;AASA;EACC,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AAND;;AASA;EACC,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;EACA,wCAAA;AAND;;AASA;EACC;IACC,kBAAA;IACA,UAAA;IACA,mBAAA;EANA;EASD;IACC,sBAAA;IACA,uBAAA;IACA,SAAA;IACA,WAAA;EAPA;EASA;IACC,sBAAA;EAPD;EAWD;IACC,eAAA;IACA,iBAAA;IACA,mBAAA;EATA;EAYD;IACC,sBAAA;IACA,uBAAA;IACA,QAAA;IACA,eAAA;EAVA;EAaD;IACC,eAAA;EAXA;EAcD;IACC,gBAAA;EAZA;AACF","sourcesContent":[".backdrop {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tbackground-color: rgba(16, 24, 40, 0.12);\r\n\tbackdrop-filter: blur(4px);\r\n\tpadding: 22px;\r\n}\r\n\r\n.modal {\r\n\tposition: relative;\r\n\twidth: 500px;\r\n\tmax-width: 95%;\r\n\tbackground: #ffffff;\r\n\tborder-radius: 16px;\r\n\tpadding: 40px 36px;\r\n\tbox-shadow: \r\n\t\t0 25px 50px rgba(15, 23, 42, 0.15),\r\n\t\t0 0 0 1px rgba(255, 255, 255, 0.05);\r\n\ttext-align: left;\r\n\t-webkit-font-smoothing: antialiased;\r\n\tanimation: modalSlideIn 0.3s ease-out;\r\n}\r\n\r\n@keyframes modalSlideIn {\r\n\tfrom {\r\n\t\topacity: 0;\r\n\t\ttransform: scale(0.95) translateY(-10px);\r\n\t}\r\n\tto {\r\n\t\topacity: 1;\r\n\t\ttransform: scale(1) translateY(0);\r\n\t}\r\n}\r\n\r\n.closeBtn {\r\n\tposition: absolute !important;\r\n\ttop: 16px;\r\n\tright: 16px;\r\n\twidth: 44px !important;\r\n\theight: 44px !important;\r\n\tmin-width: 0 !important;\r\n\tborder-radius: 50% !important;\r\n\tbackground: var(--white) !important;\r\n\tbox-shadow: 0 8px 20px rgba(17, 24, 39, 0.08) !important;\r\n\tdisplay: flex !important;\r\n\talign-items: center !important;\r\n\tjustify-content: center !important;\r\n\tpadding: 0 !important;\r\n\tcursor: pointer;\r\n\tborder: none !important;\r\n\ttransition: all 0.2s ease !important;\r\n\r\n\t&:hover {\r\n\t\tbackground: #f8f9fa !important;\r\n\t\tbox-shadow: 0 10px 25px rgba(17, 24, 39, 0.12) !important;\r\n\t\ttransform: scale(1.05);\r\n\t}\r\n\r\n\timg {\r\n\t\twidth: 20px !important;\r\n\t\topacity: 0.7;\r\n\t\ttransition: opacity 0.2s ease;\r\n\t}\r\n\r\n\t&:hover img {\r\n\t\topacity: 1;\r\n\t}\r\n}\r\n\r\n.title {\r\n\tfont: var(--h3);\r\n\tfont-family: var(--font-bodoni-72);\r\n\tfont-weight: 700;\r\n\tfont-size: 28px;\r\n\tline-height: 34px;\r\n\tcolor: #1f2937;\r\n\tmargin: 0 0 32px;\r\n\ttext-transform: none;\r\n}\r\n\r\n.detailsContainer {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 20px;\r\n}\r\n\r\n.detailRow {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: flex-start;\r\n\tpadding: 16px 0;\r\n\tborder-bottom: 1px solid #f3f4f6;\r\n\t\r\n\t&:last-child {\r\n\t\tborder-bottom: none;\r\n\t}\r\n}\r\n\r\n.label {\r\n\tfont-weight: 600;\r\n\tcolor: #374151;\r\n\tfont-size: 16px;\r\n\tmin-width: 140px;\r\n\tflex-shrink: 0;\r\n}\r\n\r\n.value {\r\n\tcolor: #1f2937;\r\n\tfont-size: 16px;\r\n\tline-height: 1.5;\r\n\ttext-align: right;\r\n\tword-break: break-word;\r\n}\r\n\r\n.statusBadge {\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tgap: 6px;\r\n\tpadding: 8px 16px;\r\n\tborder-radius: 20px;\r\n\tfont-weight: 600;\r\n\tfont-size: 14px;\r\n\ttext-transform: capitalize;\r\n\tbox-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n\t.modal {\r\n\t\tpadding: 28px 24px;\r\n\t\twidth: 90%;\r\n\t\tborder-radius: 12px;\r\n\t}\r\n\r\n\t.closeBtn {\r\n\t\twidth: 36px !important;\r\n\t\theight: 36px !important;\r\n\t\ttop: 12px;\r\n\t\tright: 12px;\r\n\r\n\t\timg {\r\n\t\t\twidth: 16px !important;\r\n\t\t}\r\n\t}\r\n\r\n\t.title {\r\n\t\tfont-size: 24px;\r\n\t\tline-height: 30px;\r\n\t\tmargin-bottom: 24px;\r\n\t}\r\n\r\n\t.detailRow {\r\n\t\tflex-direction: column;\r\n\t\talign-items: flex-start;\r\n\t\tgap: 8px;\r\n\t\tpadding: 12px 0;\r\n\t}\r\n\r\n\t.label {\r\n\t\tmin-width: auto;\r\n\t}\r\n\r\n\t.value {\r\n\t\ttext-align: left;\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backdrop": `ViewTimeOffModal_backdrop__Jlw4B`,
	"modal": `ViewTimeOffModal_modal__FwpZ3`,
	"modalSlideIn": `ViewTimeOffModal_modalSlideIn__xz8C2`,
	"closeBtn": `ViewTimeOffModal_closeBtn__I1tRp`,
	"title": `ViewTimeOffModal_title__9-0ud`,
	"detailsContainer": `ViewTimeOffModal_detailsContainer__dQdOT`,
	"detailRow": `ViewTimeOffModal_detailRow__D8+th`,
	"label": `ViewTimeOffModal_label__JgSKH`,
	"value": `ViewTimeOffModal_value__YU5w5`,
	"statusBadge": `ViewTimeOffModal_statusBadge__3kRS1`
};
export default ___CSS_LOADER_EXPORT___;
